// extracted by mini-css-extract-plugin
module.exports = {"body":"dashboard_body__1NpmA","screens":"dashboard_screens__3Fyio","screensSubMenu":"dashboard_screensSubMenu__9vaDV"};